import { format, getDaysInMonth, startOfMonth, getDay, addMonths, subMonths } from "date-fns";

export interface CalendarDay {
  date: number;
  events: {
    count: number;
    value: number;
  };
  isLastMonth?: boolean;
  isNextMonth?: boolean;
}

export const getDaysArray = (date: Date): CalendarDay[] => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const daysInMonth = getDaysInMonth(date);
  const firstDayOfMonth = startOfMonth(date);
  const startingDayIndex = getDay(firstDayOfMonth);
  
  // Use Sunday-based week (Sunday = 0, Saturday = 6)
  const sundayBasedStartDay = startingDayIndex;
  
  const days: CalendarDay[] = [];
  
  // Add days from previous month for padding at the start
  if (sundayBasedStartDay > 0) {
    // Create a date for the previous month
    const prevMonth = new Date(year, month - 1, 1);
    const daysInPrevMonth = getDaysInMonth(prevMonth);
    
    // Add the last N days from previous month
    for (let i = 0; i < sundayBasedStartDay; i++) {
      const prevMonthDay = daysInPrevMonth - sundayBasedStartDay + i + 1;
      days.push({ 
        date: prevMonthDay, 
        events: { count: 0, value: 0 },
        isLastMonth: true 
      });
    }
  }
  
  // Add actual days of the current month
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({
      date: i,
      events: {
        count: 0,
        value: 0,
      }
    });
  }
  
  // Fill remaining days with next month's dates to complete the grid
  const remainingDays = (7 - (days.length % 7)) % 7;
  if (remainingDays > 0) {
    for (let i = 1; i <= remainingDays; i++) {
      days.push({ 
        date: i, 
        events: { count: 0, value: 0 },
        isLastMonth: true, // We'll use the same property but it's actually next month
        isNextMonth: true  // Add this to differentiate from previous month if needed
      });
    }
  }
  
  return days;
};

export const getNextMonth = (date: Date): Date => addMonths(date, 1);
export const getPreviousMonth = (date: Date): Date => subMonths(date, 1);
export const formatMonth = (date: Date): string => format(date, "MMM yyyy");